import { render, staticRenderFns } from "./AficionVisitanteModal.vue?vue&type=template&id=b4569efe&scoped=true"
import script from "./AficionVisitanteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AficionVisitanteModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AficionVisitanteModal.vue?vue&type=style&index=0&id=b4569efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4569efe",
  null
  
)

export default component.exports